var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('div',{staticClass:"p-3",class:{ 'raised rounded': _vm.raised }},[_c('generic-entity-upload-documents',{ref:"documents",attrs:{"files":_vm.salesforce_documents,"uploadUrl":("users/" + (_vm.user.id) + "/entities/" + (_vm.entity.id) + "/docs")},on:{"upload-success":_vm.loadEntities}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f1b537","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/entities/EntityDocuments.vue
// module id = null
// module chunks = 